<template>
  <div>
    <el-descriptions
      class="border-detail-main-form mt-2"
      border
      size="small"
      :column="3"
    >
      <el-descriptions-item
        :label="$l('INDEX.evg_sku_label_materialCategoryName') || '物料类型'"
        :labelStyle="{ ...labelStyle }"
        :contentStyle="{ ...valueStyle, width: '200px' }"
      >
        {{ materialInfo.materialCategoryName || '' }}
      </el-descriptions-item>
      <el-descriptions-item
        :labelStyle="{ ...labelStyle }"
        :contentStyle="{ ...valueStyle, width: '300px' }"
        :label="$l('INDEX.evg_sku_label_materialName') || '物料名称'"
      >
        {{ materialInfo.materialName || '' }}
      </el-descriptions-item>
      <el-descriptions-item
        :labelStyle="{ ...labelStyle }"
        :contentStyle="{ ...valueStyle, width: '300px' }"
        :label="$l('INDEX.evg_sku_label_materialNameEn') || '英文名称'"
      >
        {{ materialInfo.materialNameEn }}
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions
      class="border-detail-main-form"
      border
      size="small"
      :column="4"
    >
      <el-descriptions-item
        :labelStyle="{ ...labelStyle }"
        :contentStyle="{ ...valueStyle, width: '200px' }"
        :label="$l('INDEX.evg_sku_label_materialNo') || '物料编号'"
      >
        {{ materialInfo.skuMaterialNo || '' }}
      </el-descriptions-item>
      <el-descriptions-item
        :labelStyle="{ ...labelStyle }"
        :contentStyle="{ ...valueStyle, width: '300px' }"
        :label="$l('INDEX.evg_sku_label_materialSpec') || '物料尺寸'"
      >
        {{ materialInfo.materialSpec || '' }}
      </el-descriptions-item>
      <el-descriptions-item
        :labelStyle="{ ...labelStyle }"
        :contentStyle="{ ...valueStyle, width: '100px' }"
        :label="$l('INDEX.evg_sku_label_isCommon') || '是否通用'"
      >
        {{
          materialInfo.isCommon == 'N'
            ? $l('INDEX.evg_sku_label_special_materials') || '专用物料'
            : materialInfo.v_isCommon
        }}
      </el-descriptions-item>
      <el-descriptions-item
        :labelStyle="{ ...labelStyle }"
        :contentStyle="{ ...valueStyle, width: '100px' }"
        :label="$l('INDEX.evg_sku_label_customerProvide') || '客户提供'"
      >
        {{ materialInfo.v_isCustomerProvide || '' }}
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions
      class="border-detail-main-form"
      border
      size="small"
      :column="5"
    >
      <el-descriptions-item
        :labelStyle="{ ...labelStyle }"
        :contentStyle="{ ...valueStyle, width: '100px' }"
        :label="$l('INDEX.evg_sku_label_specify') || '指定供应商'"
      >
        {{ materialInfo.v_isSpecify || '' }}
      </el-descriptions-item>
      <el-descriptions-item
        :labelStyle="{ ...labelStyle }"
        :contentStyle="{ ...valueStyle, width: '300px' }"
        :label="$l('INDEX.evg_sku_label_supCode') || '供应商'"
      >
        {{ materialInfo.scmName || '' }}
      </el-descriptions-item>
      <el-descriptions-item
        :labelStyle="{ ...labelStyle }"
        :contentStyle="{ ...valueStyle, width: '100px' }"
        :label="$l('INDEX.evg_sku_label_baseQty') || '基础用量'"
      >
        {{ materialInfo.baseQty || '0' }}
        {{ materialInfo.v_materialUnit || '' }}
      </el-descriptions-item>

      <el-descriptions-item
        :labelStyle="{ ...labelStyle }"
        :contentStyle="{
          ...valueStyle,
          width: '70px',
          borderRightColor: 'white',
        }"
        :label="$l('INDEX.evg_sku_label_totalProducts') || '产品合计用量'"
      >
        {{ materialInfo.totalProducts || '0' }}
        {{ materialInfo.v_materialUnit || '' }}
      </el-descriptions-item>

      <el-descriptions-item
        label=""
        :labelStyle="{ width: '30px', background: 'white', color: 'white' }"
        :contentStyle="{
          ...valueStyle,
          width: '100px',
          padding: '0px !important',
        }"
      >
        <div style="text-align: center;" v-if="!disabledEdit">
          <i
            class="el-icon-edit tool-btn"
            @click="$emit('editMaterial', materialInfo)"
          ></i>
          <i
            class="el-icon-delete tool-btn"
            style="color: red;"
            @click="$emit('delMaterial', materialInfo)"
          ></i>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions
      class="border-detail-main-form"
      border
      size="small"
      :column="2"
    >
      <el-descriptions-item
        :labelStyle="{ ...labelStyle, verticalAlign: 'top' }"
        :contentStyle="{
          ...valueStyle,
          width: '870px',
          borderRightColor: 'white',
        }"
        :label="$l('INDEX.evg_sku_label_artwork') || '物料图稿'"
      >
        <div class="m-2" style="min-height:166px;width:100%">
          <ArtworkList
            ref="artworkList"
            :evgSkuMaterialCode="evgSkuMaterialCode"
            :disabled="disabled"
            width="120px"
            height="120px"
          />
        </div>
      </el-descriptions-item>

      <el-descriptions-item
        label=""
        :labelStyle="{ width: '30px', background: 'white', color: 'white' }"
        :contentStyle="{ ...valueStyle, width: '100px', background: '#fafafa' }"
      >
        <div class="work_div" v-if="!disabled" @click="openArtWork">
          {{ $l('INDEX.evg_sku_label_edit_artwork') || '编辑图稿' }}
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions border size="small" :column="1">
      <el-descriptions-item
        :labelStyle="{ ...labelStyle }"
        :contentStyle="{ ...valueStyle, width: '1000px' }"
        :label="$l('INDEX.evg_sku_label_materialRange') || '使用范围'"
      >
        <div>
          {{ materialInfo.v_materialRange || '' }}
          <div v-if="materialInfo.materialRange == 'A'">
            <MaterialSpec :specMaterialList="materialInfo.specMaterialList" />
          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>
<script>
import ArtworkList from '../../material/artwork/ArtworkList.vue'
import MaterialSpec from '../material-spec'
export default {
  props: {
    disabled: { type: Boolean, default: true },
    isFormal: { type: Boolean, default: false },
    evgSkuCode: { type: String, default: '' },
    materialInfo: { type: Object, default: () => {} },
  },
  mixins: [],
  components: { ArtworkList, MaterialSpec },
  data() {
    return {
      labelStyle: { width: '100px', fontSize: '14px', color: '#6C6C6C' },
      valueStyle: { fontSize: '14px', color: '#101010' },
    }
  },
  computed: {
    evgSkuMaterialCode() {
      return this.materialInfo.evgSkuMaterialCode
    },
    disabledEdit() {
      return this.disabled || this.isFormal
    },
  },
  mounted() {},
  methods: {
    delMaterial() {
      this.$emit('delMaterial', this.materialInfo)
    },
    editMaterial() {
      this.$emit('editMaterial', this.materialInfo)
    },
    openArtWork() {
      this.$emit('openArtWork', this.materialInfo)
    },
    reloadArtwork() {
      this.$refs.artworkList.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.work_div {
  height: 154px;
  line-height: 154px;
  text-align: center;
  font-size: 14px;
  color: #6c6c6c;
}
</style>
